import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Footer from './components/Footer'; 
import FloatingContact from './components/FloatingContact'; // BUNU İMPORT ETTİK
import Admin from './components/Admin'; // (veya components/Admin nerede açtıysan)
import Projeler from './pages/Projeler'; // (veya pages/Projeler)
import Kameralar from './pages/Kameralar';
import KameraDetay from './components/KameraDetay';
import Urunler from './components/Urunler';
import UrunDetay from './components/UrunDetay';
import Iletisim from './pages/Iletisim';

import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        {/* Navbar her sayfada en üstte sabit kalacak */}
        <Navbar /> 

        {/* Sayfa içerikleri burada değişecek */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/iletisim" element={<Iletisim/>} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/projeler" element={<Projeler />} />
          <Route path="/kamera" element={<Kameralar />} />
          <Route path="/kamera/:id" element={<KameraDetay />} />
          <Route path="/urunler" element={<Urunler />} />
<Route path="/urun/:id" element={<UrunDetay />} />
<Route path="/urunler/:kategoriParam" element={<Urunler />} />
          
        </Routes>

        <FloatingContact />

        {/* Footer'ı Routes dışına koyduk ki her sayfanın en altında otomatik çıksın */}
        <Footer /> 
      </div>
    </Router>
  );
}

export default App;